import {
  PRODUTO_CREATE,
  PRODUTO_LOAD,
  PRODUTO_UPDATE,
  PRODUTO_LOAD_BY_COD_BARRAS,
  PRODUTO_REMOVE,
  PRODUTO_ASSOCIAR,
  PRODUTO_DESASSOCIAR,
  PRODUTO_DESASSOCIAR_TAGS,
  PRODUTOS_LOAD_BY_COD_INTERNO,
  PRODUTOS_LOAD_BY_IDS_EXTRA,
  PRODUTO_ASSOCIAR_TAGS,
  PRODUTO_LOAD_IMAGES,
  PRODUTO_REMOVE_IMAGE,
  OBTER_PRODUTOS,
  PRODUTO_REMOVE_SUBITEM,
  PRODUTO_ASSOCIAR_AGRUPADORES,
  PRODUTO_DESASSOCIAR_AGRUPADORES,
  PRODUTO_UPDATE_ESTOQUE_SEGURANCA,
  PRODUTO_UPDATE_ESTOQUE_SEGURANCA_MASSA,
  PRODUTO_CONJUNTO_DISPONIBILIDADE_MASSA,
  PRODUTO_GENERATE_DESCRIPTION
} from "../actions/produto";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";
import VueOnToast from "vue-on-toast";

export function buildGenerateDescriptionV4Payload(payload = {}) {
  const parts = [];

  if (payload.shortDescription && payload.shortDescription.trim()) {
    parts.push(`Descricao curta: ${payload.shortDescription.trim()}`);
  }
  if (payload.additionalContext && payload.additionalContext.trim()) {
    parts.push(payload.additionalContext.trim());
  }

  const additionalNames = (payload.additionalNames || [])
    .map(name => (name || "").trim())
    .filter(Boolean);

  return {
    descricao: (payload.productName || "").trim(),
    tag_pesquisa: additionalNames.length ? additionalNames : undefined,
    additionalContext: parts.length ? parts.join("\n") : undefined
  };
}

export function mapGenerateDescriptionV4Response(resp) {
  const body = resp?.data || {};

  return {
    descriptionHtml: body.data?.html,
    provider: "openai",
    generationId: body.metadata?.requestId
  };
}

export function normalizeGenerateDescriptionError(error) {
  const status = error.response?.status;
  const apiError = error.response?.data || {};
  const code = apiError.code || apiError.error?.code;

  if (error.code === "ECONNABORTED" || code === "TIMEOUT") {
    return {
      code: "TIMEOUT",
      message: "A geracao demorou mais que o esperado. Tente novamente.",
      retryable: true,
      original: error
    };
  }

  if (status === 429 || code === "RATE_LIMIT" || code === "RATE_LIMITED") {
    return {
      code: "RATE_LIMIT",
      message:
        "Limite de 10 produtos por minuto atingido para este fornecedor. Aguarde e tente novamente.",
      retryable: true,
      original: error
    };
  }

  if (
    status === 503 ||
    code === "SERVICE_UNAVAILABLE" ||
    code === "OPENAI_UNAVAILABLE"
  ) {
    return {
      code: "UNAVAILABLE",
      message: "Servico de IA indisponivel no momento. Tente em instantes.",
      retryable: true,
      original: error
    };
  }

  if (status === 400 || code === "VALIDATION_ERROR") {
    return {
      code: "VALIDATION",
      message: "Nao foi possivel gerar a descricao com os dados informados.",
      retryable: false,
      original: error
    };
  }

  return {
    code: "UNKNOWN",
    message: "Ocorreu um erro inesperado ao gerar a descricao.",
    retryable: true,
    original: error
  };
}

const state = {};

const getters = {};

const actions = {
  [PRODUTO_CREATE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v2.produto
        .inserirProduto(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PRODUTO_UPDATE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v2.produto
        .atualizarProduto(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.dara);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PRODUTO_REMOVE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v2.produto
        .removeProdutoExtra(getters.getFornecedorId, payload)
        .then(resolve)
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PRODUTO_DESASSOCIAR]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v2.setoresProduto
        .desassociarSetoresProdutos(getters.getFornecedorId, payload)
        .then(resp => {
          if (resp.data && resp.data.ok) {
            resolve();
          } else {
            VueOnToast.ToastService.pop(
              "error",
              "Erro ao desassociar categorias"
            );
            reject();
          }
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [PRODUTO_ASSOCIAR]: (
    { dispatch, getters },
    { setores, alvos, disponibilidade = null }
  ) => {
    return new Promise((resolve, reject) => {
      Api.v2.setoresProduto
        .aplicarSetoresProdutos(
          getters.getFornecedorId,
          setores,
          alvos,
          disponibilidade
        )
        .then(resp => {
          if (resp.data && resp.data.error) {
            VueOnToast.ToastService.pop(
              "error",
              "Erro ao aassociar categorias"
            );
            reject(resp.data.error);
          } else {
            resolve(resp.data);
          }
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PRODUTO_LOAD]: (
    { dispatch, getters },
    { idproduto, idcadastroextraproduto }
  ) => {
    return new Promise((resolve, reject) => {
      Api.v2.produto
        .findById(getters.getFornecedorId, idproduto, idcadastroextraproduto)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [PRODUTO_LOAD_BY_COD_BARRAS]: ({ dispatch, getters }, { codigobarras }) => {
    return new Promise((resolve, reject) => {
      Api.v2.produto
        .findByCodBarras(getters.getFornecedorId, codigobarras)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [PRODUTOS_LOAD_BY_COD_INTERNO]: ({ dispatch, getters }, { ids, page }) => {
    return new Promise((resolve, reject) => {
      // idfornecedor, ids, page
      Api.v4.produto
        .getProdutosByIdsErp(getters.getFornecedorId, ids, page)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [PRODUTOS_LOAD_BY_IDS_EXTRA]: ({ dispatch, getters }, { ids, page }) => {
    return new Promise((resolve, reject) => {
      Api.v4.produto
        .getProdutosByIdsExtra(getters.getFornecedorId, ids, page)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [PRODUTO_DESASSOCIAR_TAGS]: ({ dispatch }, { idscadastroextra }) => {
    return new Promise((resolve, reject) => {
      Api.v4.produto.tagPesquisa
        .desassocia({
          idscadastroextra
        })
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [PRODUTO_ASSOCIAR_TAGS]: (
    { dispatch },
    { idscadastroextra, idstagpesquisas, substituir }
  ) => {
    return new Promise((resolve, reject) => {
      Api.v4.produto.tagPesquisa
        .associa({
          idscadastroextra,
          idstagpesquisas,
          substituir
        })
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [PRODUTO_LOAD_IMAGES]: (
    { dispatch, getters },
    { idcadastroextraproduto }
  ) => {
    return new Promise((resolve, reject) => {
      Api.v2.produto
        .buscaImagens(getters.getFornecedorId, idcadastroextraproduto)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [PRODUTO_REMOVE_IMAGE]: (
    { getters, dispatch },
    { idcadastroextraproduto, imagem }
  ) => {
    return new Promise((resolve, reject) => {
      Api.v2.produto
        .removeImagem(getters.getFornecedorId, idcadastroextraproduto, imagem)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [PRODUTO_REMOVE_SUBITEM]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.produto
        .removeSubItem(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [OBTER_PRODUTOS]: ({ getters, dispatch }, search) => {
    return new Promise((resolve, reject) => {
      Api.v1.produto
        .obtemProdutos(getters.getFornecedorId, search)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [PRODUTO_ASSOCIAR_AGRUPADORES]: ({ dispatch }, payload) => {
    const { idscadastroextra, idagrupadores, substituir } = payload;
    return new Promise((resolve, reject) => {
      Api.v4.produto.agrupador
        .associa({
          idscadastroextra,
          idagrupadores,
          substituir
        })
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [PRODUTO_DESASSOCIAR_AGRUPADORES]: ({ dispatch }, payload) => {
    const { idscadastroextra } = payload;
    return new Promise((resolve, reject) => {
      Api.v4.produto.agrupador
        .desassocia({
          idscadastroextra
        })
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [PRODUTO_UPDATE_ESTOQUE_SEGURANCA]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.product
        .updateEstoqueSeguranca(
          getters.getFornecedorId,
          payload.idcadastroextraproduto,
          {
            tipo_calculo: payload.tipo_calculo,
            valor_aplicado: payload.valor_aplicado
          }
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [PRODUTO_UPDATE_ESTOQUE_SEGURANCA_MASSA]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.product
        .updateEstoqueSegurancaMassa(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [PRODUTO_CONJUNTO_DISPONIBILIDADE_MASSA]: (
    { dispatch, getters },
    { idscadastroextra, habilitar }
  ) => {
    return new Promise((resolve, reject) => {
      Api.v4.product
        .updateConjuntoDisponibilidadeMassa(
          getters.getFornecedorId,
          idscadastroextra,
          habilitar
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [PRODUTO_GENERATE_DESCRIPTION]: async (_, { idfornecedor, payload }) => {
    try {
      const resp = await Api.v4.product.generateDescription(
        idfornecedor,
        buildGenerateDescriptionV4Payload(payload)
      );
      return mapGenerateDescriptionV4Response(resp);
    } catch (error) {
      throw normalizeGenerateDescriptionError(error);
    }
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
